import { ArticleRowListSchema, type ArticleRow } from '../../../shared/schemas/article';
import { logger } from '@/app/logger';
import { getPublicContent } from './publicContentCache';

const log = logger.create('site:articlesPublicApi');

const validatedLists = new Map<string, ArticleRow[]>();

export function peekPublishedArticles(fetchUrl: string): ArticleRow[] | undefined {
  return validatedLists.get(fetchUrl);
}

export async function fetchPublishedArticles(fetchUrl: string) {
  const cached = validatedLists.get(fetchUrl);
  if (cached) {
    return cached;
  }

  log.debug('fetchPublishedArticles', 'Requesting article list', { fetchUrl });

  const raw = await getPublicContent<unknown>(fetchUrl);
  const parsed = ArticleRowListSchema.safeParse(raw);

  if (!parsed.success) {
    log.error('fetchPublishedArticles', 'Response validation failed', {
      fetchUrl,
      issueCount: parsed.error.issues.length,
    });
    throw new Error('Invalid article list response');
  }

  validatedLists.set(fetchUrl, parsed.data);

  log.debug('fetchPublishedArticles', 'Response validated', {
    fetchUrl,
    count: parsed.data.length,
  });

  return parsed.data;
}
